export const COUPON_TYPE_PERCENT = 1;
export const COUPON_TYPE_PRICE = 2;